module.exports = __webpack_public_path__ + "img/2.9f5246dd.gif";